import dynamic from "next/dynamic"

export const ImageNoSSR = dynamic(() => import("next/image"), { ssr: false })
